import request from '@utils/request'

const taskApi = {
    getStatistics: '/train/rest/task/get_statistics',
    getPage: '/train/rest/task/get_page',
    _add: '/train/rest/task/_add',
    _update: '/train/rest/task/_update',
    remove: '/train/rest/task/remove',
    addConfig: '/train/rest/task/add_config',
    updateConfig: '/train/rest/task/update_config',
    startTraining: '/train/rest/task/start_training',
    getListStatus: '/train/rest/task/get_list_status',
    getTrainLog: '/train/rest/task/get_train_log',
    defaultgetTrainLog: '/train/rest/task/v2/get_train_log',
    download1: '/train/rest/file/download_train_model/',
    download2: '/train/rest/file/download_train_model_onnx/',
    defaultgetTrainLog2: '/train/rest/task/v2/get_train_log2',
    setBreak: 'train/rest/task/set_hand_break',
    getTrainVerifyPage: 'train/rest/task/get_train_verify_page/',
    // /rest/get_convert_model_task/{taskId}
    getConvertModelTask: 'train/rest/file/get_convert_model_task/',
    getTransLists: 'train/rest/task/get_convert_task_page/',
    getModelName: 'train/rest/file/get_model_info_before_download/',
}
export function getModelName({ id, type }) {
    return request({
        url: taskApi.getModelName + `${id}/${type}`,
        method: 'get',
    })
}
export function getTramsList({ pageIndex, pageSize }) {
    return request({
        url: taskApi.getTransLists + `${pageIndex}/${pageSize}`,
        method: 'get',
    })
}
export function getConvertModelTask(taskId) {
    return request({
        url: taskApi.getConvertModelTask + `${taskId}`,
        method: 'get',
    })
}

export function getTaskStatics(parameter) {
    return request({
        url: taskApi.getStatistics,
        method: 'get',
        params: parameter
    })
}

export function getPage(parameter) {
    return request({
        url: taskApi.getPage,
        method: 'get',
        params: parameter
    })
}
export function _add(parameter) {
    return request({
        url: taskApi._add,
        method: 'post',
        data: parameter
    })
}

export function _update(parameter) {
    return request({
        url: taskApi._update,
        method: 'post',
        data: parameter
    })
}

export function remove(parameter) {
    return request({
        url: taskApi.remove,
        method: 'post',
        data: parameter
    })
}

export function addConfig(parameter) {
    return request({
        url: taskApi.addConfig,
        method: 'post',
        data: parameter
    })
}

export function updateConfig(parameter) {
    return request({
        url: taskApi.updateConfig,
        method: 'post',
        data: parameter
    })
}

export function startTraining(parameter) {
    return request({
        url: taskApi.startTraining,
        method: 'post',
        data: parameter
    })
}
export function getListStatus(parameter) {
    return request({
        url: taskApi.getListStatus,
        method: 'post',
        data: parameter
    })
}

export function getTrainLog(parameter) {
    return request({
        url: taskApi.getTrainLog,
        method: 'get',
        params: parameter
    })
}

export function defaultgetTrainLog(parameter) {
    return request({
        url: taskApi.defaultgetTrainLog,
        method: 'get',
        params: parameter
    })
}

export function defaultgetTrainLog2(parameter) {
    return request({
        url: taskApi.defaultgetTrainLog2,
        method: 'get',
        params: parameter
    })
}

export function getdownload1(parameter) {
    return request({
        url: taskApi.download1 + `${parameter}`,
        method: 'get',
    })
}

export function getdownload2(parameter) {
    return request({
        url: taskApi.download2 + `${parameter}`,
        method: 'get',
    })
}

export function getmodelList2(parameter) {
    return request({
        url: '/train/rest/task/get_train_model_list2/' + `${parameter}`,
        method: 'get',
    })
}

export function setBreak(parameter) {
    return request({
        url: taskApi.setBreak,
        method: 'post',
        data: parameter
    })
}

export function getTrainVerifyPage(parameter) {
    return request({
        url: taskApi.getTrainVerifyPage + `${parameter.taskId}`,
        method: 'get',
        params: parameter
    })
}
